import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { ExaminationModel } from '../models/ExaminationModel';
import { URLsConfig } from '../URLsConfig';
import { PathologyModel } from '../models/PathologyModel';

@Injectable()
export class ExaminationService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    public getexamination(patientCode: string ,dateentry: string, comCode: string) {
      let params = new HttpParams();
        params = params.append("patientCode", patientCode);
        params = params.append("dateentry", dateentry);
        params = params.append("compCode", comCode);
        const options = {
            params: params
        };
        return this.http.get<ExaminationModel>(this.urlsconfig.WebAPIURL_Test + 'api/Examination/GetExamination',options);
    }
    public Addexamination(PatientData: ExaminationModel) {
        return this.http.post<ExaminationModel>(this.urlsconfig.WebAPIURL_Test + 'api/Examination/Addnewexamination', PatientData);
    }
    public AddExAttach(users: ExaminationModel) {
      return this.http.post<ExaminationModel>(this.urlsconfig.WebAPIURL_Test + 'api/Examination/AddExAttach', users);
  }
    ///
   
  public getExaminitionLookup_Patient(patientCode:string ,compCode: string) {
    let params = new HttpParams();
    params = params.append("PatientCode", patientCode);
    params = params.append("compCode", compCode);
    const options = {
        params: params
    };
    return this.http.get<ExaminationModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Examination/ExaminationLookupTop_Patient', options);
}
public getExaminitionLookup(compCode: string) {
  let params = new HttpParams();
  params = params.append("compCode", compCode);
  const options = {
      params: params
  };
  return this.http.get<ExaminationModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Examination/ExaminationLookupTop', options);
}
public getExamTypeLookup(compCode: string) {
let params = new HttpParams();
params = params.append("compCode", compCode);
const options = {
    params: params
};
return this.http.get<PathologyModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Examination/ExamTypeLookupTop', options);
}
  }
